export default __webpack_public_path__ + "static/media/(48).70ca6b91.JPG";